import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import { registerTeacherReducer } from '../Slices/registerTeachers.slice';
const registerTeacherConfig = {
  key: 'register-teacher',
  version: 1,
  storage,
};

export const persistedRegisterTeacher = persistReducer(
  registerTeacherConfig,
  registerTeacherReducer
);
